import { render, staticRenderFns } from "./cms-component-image.vue?vue&type=template&id=5aa5999b&scoped=true"
import script from "./cms-component-image.vue?vue&type=script&lang=js"
export * from "./cms-component-image.vue?vue&type=script&lang=js"
import style0 from "./cms-component-image.vue?vue&type=style&index=0&id=5aa5999b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa5999b",
  null
  
)

export default component.exports